import "core-js/modules/es.regexp.exec.js";
import Cookies from 'js-cookie';
import { CookieKey } from '~/core/enums';
import { isAppSupported } from '~/core/functions';
import useMainStore from '~/stores/useMainStore';
export var useSmartAppBannerSetup = function useSmartAppBannerSetup() {
  var mainStore = useMainStore();
  var _useNuxtApp = useNuxtApp(),
    $device = _useNuxtApp.$device,
    $sentry = _useNuxtApp.$sentry;
  onBeforeMount(function () {
    var isYaBrowser = /YaBrowser/i.test(navigator.userAgent);
    var isIOSSafari = $device.isIos && $device.isSafari && !isYaBrowser;
    var isCookieWasSet = Cookies.get(CookieKey.AppSmartBannerWasClosed);
    mainStore.isSmartAppBannerActive = !isCookieWasSet && !isIOSSafari && isAppSupported({
      $device: $device,
      $sentry: $sentry
    });
  });
};